import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogExportDataOptions, ExportCriteria, MessageType } from '@caslink/common-client';
import { HttpErrorResponse } from '@angular/common/http';
import { ExportSensorDataService } from '@caslink/common-client/ng-app/exportSensorData/ExportSensorDataService';
import { DialogService } from '@caslink/common-client/ng-app/dialog-service/dialog.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as moment from 'moment';

@Component({
    selector: 'export-sensor-dialog.component',
    styleUrls: ['export-sensor-dialog.component.scss'],
    templateUrl: 'export-sensor-dialog.component.html',
    providers: [
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
    ],
})
export class ExportSensorDialogComponent implements OnInit {
    fgExportData: FormGroup;

    constructor(
        private dialogRef: MatDialogRef<ExportSensorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogExportDataOptions,
        private exportSensorDataService: ExportSensorDataService,
        private dialogService: DialogService,
        private formBuilder: FormBuilder
    ) {
    }

    public ngOnInit() {
        this.fgExportData = this.formBuilder.group({
            startDate: [moment(new Date(this.data.startDate)), Validators.required],
            endDate: [moment(new Date(this.data.endDate)), Validators.required],
            exportType: new FormControl('points')
        });
    }

    public confirmAction() {
        const criteria: ExportCriteria = {
            startDate: this.fgExportData.get('startDate').value.toDate().getTime(),
            endDate: this.fgExportData.get('endDate').value.toDate().getTime(),
            exportType: this.fgExportData.get('exportType').value,
            sensorIds: this.data.sensorIds
        };

        this.exportSensorDataService.exportSensorData(criteria).subscribe(
            () => {
                this.dialogRef.close(true);
            },
            (reason: HttpErrorResponse) => {
                (reason.error as Blob)['text']().then(err => {
                    const message = JSON.parse(err).exceptionMessage;
                    this.dialogRef.close(false);
                    this.dialogService.showMessageDialog('Error', message, MessageType.Info);
                });
            });
    }

    public cancelAction() {
        this.dialogRef.close(false);
    }
}
